import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { motion } from "framer-motion";
import logo from '../images/emptysack.png'; // your logo path
import videoBackground from '../images/FoodSakzBackground.mp4'; // **Your new video file path**

export default function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative', // Set up for absolute positioning of the video
        textAlign: 'center',
        py: 10,
        color: '#fff',
        overflow: 'hidden', // Ensures video edges are contained
        minHeight: '400px', // Set a minimum height for the section
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* The Video Element
        It is absolutely positioned to cover the entire Box and sits behind the content.
      */}
      <video
        autoPlay // Start playing automatically
        loop // **This is what makes it repeat**
        muted // Muted is often required for autoplay on many browsers
        playsInline // Ensures it plays correctly on mobile devices
        style={{
          position: 'absolute', 
          width: '100%',
          height: '100%',
          objectFit: 'cover', // Ensures the video covers the entire area without distortion
          top: 0,
          left: 0,
          zIndex: 0, // Keep the video behind the main content
        }}
      >
        <source src={videoBackground} type="video/mp4" />
        {/* Fallback for browsers that don't support HTML5 video */}
        Your browser does not support the video tag.
      </video>

      {/* Overlay Content
        This is a translucent overlay to ensure the text is readable over the video.
      */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.2)', // Dark overlay for better text contrast
          zIndex: 1, // Put the overlay between the video and the content
        }}
      />
 
<Box sx={{ zIndex: 2 }}>
        {/* Logo Animation: From left to center */}
        <motion.div
          initial={{ x: -200, opacity: 0 }} // Start off-screen to the left
          animate={{ x: 0, opacity: 1 }}    // Animate to center
          transition={{ duration: 0.8, delay: 0.15 }} // Slightly delayed from video, but before text
        >
          <img
            src={logo}
            alt="Logo"
            width={120}
            height={120}
            style={{
              marginBottom: 20,
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </motion.div>

        {/* Text Animation: Delayed start */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }} // CONTENT WILL APPEAR AFTER 0.5 SECONDS
        >
          <Typography variant="h3" fontWeight="bold">
            Foodsakz -  Your Online Grocery Destination
          </Typography>
        </motion.div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.17 }} // Slightly delay this line after the main heading
        >
            <Typography variant="h6" sx={{ mt: 2 }}>
                Freshness, quality, and convenience — delivered to your door.
            </Typography>
        </motion.div>
      </Box>
    </Box>
  );
}